import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {OrganisationsService} from '../services/organisations.service';
import {Organisation} from '../models/organisation';

@Injectable()

/**
 * OrganisationResolver resolves request to get the current authenticated users' organisation
 */
export class OrganisationResolver implements Resolve<Organisation>
{
	/**
	 * OrganisationResolver constructor
	 *
	 * @param {OrganisationsService} organisationsService
	 */
	constructor(private organisationsService: OrganisationsService)
	{
	}

	/**
	 * Provides data to a route
	 *
	 * @returns {Observable<Invoice[]>}
	 */
	resolve(): Observable<Organisation>
	{
		return this.organisationsService.getOrganisation();
	}
}



// WEBPACK FOOTER //
// ./src/app/resolvers/organisation.resolver.ts